import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
// import BudgetMulti from '../../../widgets/budget/BudgetMulti'
// import BudgetNew from '../../../widgets/budget/Budget'
import { getSchemaPaymentSave, getSchemaPaymentSaveMulti } from '../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

import { findIndex, isEmpty } from 'lodash-es'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import SelectedExpertList from '../../../widgets/selectedExpert/selecedExpertList/SelectedExpertList'
import { Col, Message, Panel, Row } from 'rsuite'
import SeachExpertWidget from '../../../widgets/selectedExpert/seachExpert/SeachExpertWidget'
import pathname from '../../../constants/pathname'
import { getSchemaAssignExpertMuti } from '../../../redux/actions/assignExpert'
import Budget from '../../../widgets/budget/Budget'
import scrollToComponent from 'react-scroll-to-component'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { getReviewSummaryMutiData } from '../../../redux/actions/reviewSummary'

export default function PaymentSaveMulti() {
  const [isLoading, setIsLoading] = useState(false)
  const [isReLoading, setIsReLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [paymentSave, setPaymentSave] = useState()
  const [section, setSection] = useState()
  const [dataTableSection, setDataTableSection] = useState()
  const [singleProject, setSingleProject] = useState()
  const [singleError, setSingleError] = useState()
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  const [projectIdList, setProjectIdList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  // const projectId = '0219B95A-097A-444C-B903-7F39EBBBA6EE'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //let request = getRequestBody()
      let request = {
        groupId: projectId,
      }
      //console.log('handleGetSchema request', request)
      setPaymentSave('')
      setSingleProject('')
      const _schema = await getSchemaPaymentSaveMulti(request, 5, 1)
      //console.log('handleGetSchema response', _schema)

      //Mock budgetInstallmentPlan
      // _schema.forms.projectBudget['budgetInstallmentPlan'] = budgetInstallmentPlan

      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)

      // MOCK
      // setSchema(mockSchema)
      // setProjectList(mockSchema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = async (obj) => {
    console.log('obj', obj)
    setSingleError(false)
    startLoading()
    try {
      setPaymentSave('')
      setSingleProject(obj)
      const response = await getSchemaPaymentSave(obj.id)
      console.log('response', response)

      let _schema = response?.model?.forms

      if (_schema) {
        _schema['header'] = (
          <div>
            <Col xs={20} sm={20} md={20} lg={20}>
              {obj.projectName}
            </Col>
            <Col xs={4} sm={4} md={4} lg={4} align="right">
              <CancelButton
                onClick={() => {
                  setPaymentSave('')
                }}
              >{`ปิด`}</CancelButton>
            </Col>
          </div>
        )
        setPaymentSave(_schema)
      }
    } catch (e) {
      console.log('e', e)
      setSingleError(true)
    }
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    doneLoading()
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      // let request = getRequestBody()
      let request = {
        groupId: projectId,
      }
      console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      setPaymentSave('')
      setSingleProject('')
      const response = await getSchemaPaymentSaveMulti(request, pagesize, pagenumber)
      // const response = await getReviewSummaryMutiData(request, pagesize, pagenumber)
      setProjectList(response?.forms?.projectList || [])
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const onComplete = () => {
    reactScrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    handleReload(5, 1)
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        id: idList,
      }
    }
    setProjectIdList(request.id.split(','))
    setRequestBody(request)
    return request
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {1 != 1 && schema?.forms?.projectBudget?.isEnableMulti && (
        <div>
          {/* <BudgetMulti */}
          {/* Multi */}
          <Budget
            schema={schema.forms.projectBudget}
            isEditable={true}
            isEditableBudgetPlan={true}
            projectIdList={projectIdList}
            onComplete={handleReload}
            isMulti={true}
            isEditableBudgetInstallmentPlan={true}
          />
          <br />
        </div>
      )}

      <Row
        ref={(section) => {
          setDataTableSection(section)
        }}
      ></Row>

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            single={{
              enable: true,
              buttonText: projectList.buttonText || 'บันทึกงวดเงิน',
              iconByStatus: true,
              hideText: false,
              width: 160,
            }}
            onSingleSubmit={onSingleSubmit}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <Row
        ref={(section) => {
          setSection(section)
        }}
      >
        {singleError && (
          <>
            <Message
              showIcon
              type="error"
              description={`ดึงข้อมูลโครงการ ${singleProject?.projectName} ไม่สำเร็จ`}
            />
            <br />
          </>
        )}
      </Row>

      {paymentSave && (
        <div>
          <Budget
            schema={paymentSave}
            isEditable={true}
            isEditableBudgetPlan={true}
            isEditableBudgetInstallmentPlan={true}
            projectVersionId={singleProject.id}
          />
          <br />
        </div>
      )}
    </SidebarProposal>
  )
}
